import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconZing: React.FC<IconProps> = (props) => (
  <svg width="52" height="14" viewBox="0 0 52 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#icon-zing-a)">
      <path
        d="M46.7845 13.0825C45.8549 13.0825 44.998 12.9369 44.214 12.6457C43.4412 12.3433 42.7636 11.9177 42.1812 11.3688C41.6099 10.82 41.1619 10.176 40.8371 9.43679C40.5235 8.69757 40.3667 7.88555 40.3667 7.00072C40.3667 6.1159 40.5235 5.30387 40.8371 4.56465C41.1619 3.82543 41.6155 3.18141 42.198 2.6326C42.7804 2.08378 43.4636 1.66377 44.2476 1.37256C45.0316 1.07015 45.8941 0.918945 46.8349 0.918945C47.8765 0.918945 48.8117 1.09255 49.6406 1.43976C50.4806 1.78697 51.1862 2.29098 51.7574 2.9518L50.0102 4.56465C49.5846 4.11664 49.1198 3.78623 48.6157 3.57342C48.1117 3.34942 47.5629 3.23741 46.9693 3.23741C46.3981 3.23741 45.8773 3.32702 45.4068 3.50622C44.9364 3.68543 44.5276 3.94303 44.1804 4.27904C43.8444 4.61505 43.5812 5.01266 43.3908 5.47188C43.2116 5.93109 43.122 6.44071 43.122 7.00072C43.122 7.54954 43.2116 8.05355 43.3908 8.51277C43.5812 8.97198 43.8444 9.37519 44.1804 9.7224C44.5276 10.0584 44.9308 10.316 45.39 10.4952C45.8605 10.6744 46.3757 10.764 46.9357 10.764C47.4733 10.764 47.9941 10.68 48.4981 10.512C49.0133 10.3328 49.5118 10.036 49.9934 9.6216L51.539 11.5873C50.9006 12.0689 50.1558 12.4385 49.3046 12.6961C48.4645 12.9537 47.6245 13.0825 46.7845 13.0825ZM49.0526 11.2344V6.81592H51.539V11.5873L49.0526 11.2344Z"
        fill="white"
      />
      <path
        d="M25.0175 12.8805V1.12012H27.2687L34.2073 9.58756H33.1153V1.12012H35.8034V12.8805H33.5689L26.6135 4.41301H27.7055V12.8805H25.0175Z"
        fill="white"
      />
      <path d="M16.1448 12.8805V1.12012H18.8665V12.8805H16.1448Z" fill="white" />
      <path
        d="M0.757202 12.8805V11.1164L8.03181 2.34655L8.36782 3.33778H0.891606V1.12012H10.7871V2.88417L3.52928 11.654L3.19327 10.6628H11.0391V12.8805H0.757202Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="icon-zing-a">
        <rect width="51.0002" height="12.1636" fill="white" transform="translate(0.757202 0.918945)" />
      </clipPath>
    </defs>
  </svg>
);
